import React, { useState, useEffect } from "react";
import * as Icon from "react-feather";
import { ToastContainer, toast } from "react-toastify";
import { backendApi } from "../../api/apiService.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { format, fromUnixTime } from "date-fns";
import moment from "moment";
import ConfirmationPopup from "./confirmationPopup.jsx";

function ScheduleInterviewPopup({ onClose, candidateId, opening }) {
  const [isLoading, setIsLoading] = useState(false);
  const [interviewers, setInterviewers] = useState([]);
  const [openingTypes, setOpeningTypes] = useState([]);
  const [openingType, setOpeningType] = useState("");
  const [department, setDepartment] = useState("");
  const [interviewerIds, setInterviewerIds] = useState([]);
  const [interviewerSelected, setInterviewerSelected] = useState([]);
  const [interviewType, setInterviewType] = useState("Online");
  const [suggestion, setSuggestion] = useState("");
  const [location, setLocation] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [formattedFromDate, setFormattedFromDate] = useState();
  const [formattedToDate, setFormattedToDate] = useState();
  const [title, setTitle] = useState("");
  const [interviewLink, setInterviewLink] = useState("");

  useEffect(() => {
    initialValues();
    scheduleInit();
  }, []);

  const initialValues = () => {
    console.log("openid", opening);
    if (opening) {
      setOpeningType(opening.id);
      setLocation(opening.location);
    }
  };

  const handleFromDateChange = (date) => {
    setFrom(date);
    const toDate = new Date(date);
    setTo(toDate);
  };

  const Cancel = () => {
    setTitle("");
    setShowPopup(false);
  };

  const handleFromTimeChange = (time) => {
    setStartTime(time);
    const newEndTime = new Date(time);
    newEndTime.setMinutes(newEndTime.getMinutes() + 30);
    setEndTime(newEndTime);
  };

  const resetForm = () => {
    setOpeningType("");
    setDepartment("");
    setInterviewerIds([]);
    setInterviewerSelected([]);
    setInterviewType("");
    setSuggestion("");
    setLocation("");
    setFrom(new Date());
    setTo(new Date());
  };

  const handleSwitchChange = (checked) => {
    setInterviewType(checked ? "online" : "offline");
  };

  const scheduleInit = () => {
    var req = {
      functionName: "scheduleInit",
      site_id: localStorage.getItem("siteId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        //setInterviewers(response.users);
        const transformedOptions = response.users.map((user) => ({
          value: user.id,
          label: user.fullName,
        }));
        setInterviewers(transformedOptions);
        // setOpeningTypes(response.openingJob);
        const activeJobs = response.openingJob.filter(job => job.is_active === 1);
        setOpeningTypes(activeJobs);
      } else {
        console.log("Error while fetching schedule interview data");
        return false;
      }
    });
  };

  const handleAssignSelectChange = (selectedOption) => {
    setInterviewerIds(selectedOption);
    const selectedOptions = selectedOption.map((item) => String(item.value));
    setInterviewerSelected(selectedOptions);
    console.log(selectedOptions);
  };

  const createInterview = () => {
    if (openingType === "") {
      toast.warn("Please choose an opening", {
        containerId: "F",
      });
      return false;
    } else if (location === "") {
      toast.warn("Please enter location", {
        containerId: "F",
      });
      return false;
    } else if (department === "") {
      toast.warn("Please enter department", {
        containerId: "F",
      });
      return false;
    } else if (!interviewerIds.length > 0) {
      toast.warn("Please select interviewer", {
        containerId: "F",
      });
      return false;
    } else if (from === "") {
      toast.warn("Please select Interview Date", {
        containerId: "F",
      });
      return false;
    } else if (startTime === null) {
      toast.warn("Please select Interview Start Time", {
        containerId: "F",
      });
      return false;
    } else if (to === "") {
      toast.warn("Please select Interview Date", {
        containerId: "F",
      });
      return false;
    } else if (endTime === null) {
      toast.warn("Please select Interview End Time", {
        containerId: "F",
      });
      return false;
    } else if (
      moment(from).format("YYYY-MM-DD") !== moment(to).format("YYYY-MM-DD")
    ) {
      toast.warn("Interview should be held on the same day", {
        containerId: "F",
      });
      return false;
    } else if (startTime.getTime() >= endTime.getTime()) {
      toast.warn("End time must be after start time", {
        containerId: "F",
      });
      return false;
    } else if (interviewType === "") {
      toast.warn("Please select interview type", {
        containerId: "F",
      });
      return false;
    }

    console.log("SD", from);
    console.log("ST", startTime);
    console.log("ED", to);
    console.log("ET", endTime);
    const startDateTime = moment(from)
      .startOf("day")
      .add(moment(startTime).diff(moment(startTime).startOf("day")));
    setFormattedFromDate(startDateTime.format("DD MMM YYYY h:mm A"));

    const endDateTime = moment(to)
      .startOf("day")
      .add(moment(endTime).diff(moment(endTime).startOf("day")));
    setFormattedToDate(endDateTime.format("DD MMM YYYY h:mm A"));

    // const formattedFromDate = moment(from).set({
    //   hour: startTime.getHours(),
    //   minute: startTime.getMinutes(),
    //   second: 0,
    //   millisecond: 0
    // }).toISOString();

    // const formattedToDate = moment(to).set({
    //   hour: endTime.getHours(),
    //   minute: endTime.getMinutes(),
    //   second: 0,
    //   millisecond: 0
    // }).toISOString();

    setTitle("Schedule");
    setShowPopup(true);
    return;
  };

  const [DepartmentData, setDepartmentData] = useState([])
  useEffect(() => {
    getAllDepartments();
  }, []);
  const getAllDepartments = () => {
    var req = {
      functionName: "departmentProjectListing",
      site_id: localStorage.getItem("siteId"),
      is_active: "1"
    };
    backendApi(req).then((response) => {
      console.log('Status Results', response);
      if (response.success == 1) {
        console.log("req", response);
        setDepartmentData(response.dataSet)
      } else {
        console.log("Error in status viewing.");
        return false;
      }
    });
  };


  const scheduleInterview = () => {
    if (location === "") {
      toast.warn("Please enter a location", { containerId: "F" });
      return false;
    } else if (department === "") {
      toast.warn("Please enter department name", { containerId: "F" });
      return false;
    } else if (interviewerSelected.length === 0) {
      toast.warn("Please select an interviewer", { containerId: "F" });
      return false;
    }
    var req = {
      functionName: "saveInterview",
      site_id: localStorage.getItem("siteId"),
      opening_job_id: openingType,
      department_name: department,
      start_date: formattedFromDate,
      end_date: formattedToDate,
      Interviewer_id: interviewerSelected,
      candidate_id: candidateId,
      interview_type: interviewType,
      suggestion: suggestion,
      location: location,
      created_by: localStorage.getItem("userId"),
      interviewLink: interviewLink,
    };
    setIsLoading(true)
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        resetForm();
        toast.success("Interview Scheduled Successfully", { containerId: "F" });
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        toast.warn("Something went wrong", { containerId: "F" });
        return false;
      }
    }).finally(() => {
      setIsLoading(false)
      setShowPopup(false)
    });
  };

  return (
    <div className="modal_parent schedulePopup" id="addPeople">
      <ToastContainer
        enableMultiContainer
        containerId={"F"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="module_popup addPeople bfAddPeople module_popupxl">
        <div className="module_innerpopup module_bodypop">
          <div className="module_headdiv">
            <h4 className="popup_head py-2">Schedule Interview</h4>
            {/* <div className="module_close">
              <Icon.X color="grey" size={18} />
            </div> */}
          </div>
          <div className="module_body py-4">
            <div className="row">
              <div className="form-group col-md-6">
                <label htmlFor="" className="form-label">
                  Opening<span className="text-danger ml-1">*</span>
                </label>
                <select
                  id="role-select"
                  className="form-control popupControlSelect"
                  value={openingType}
                  onChange={(event) => setOpeningType(event.target.value)}
                >
                  <option value="">Choose Opening</option>
                  {openingTypes.map((opening) => (
                    <option key={opening.id} value={opening.id}>
                      {opening.summary}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-md-6">


                <label htmlFor="" className="form-label">
                  Location<span className="text-danger ml-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Location Here"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
              </div>


              <div className="form-group col-md-6">
                <label htmlFor="" className="form-label">
                  Department Name<span className="text-danger ml-1">*</span>
                </label>
                {/* <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Department Name"
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                /> */}
                <select
                  className="form-control"
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                >
                  <option value="">Select Project Or Department Name</option>
                  {DepartmentData.map((priority) => (
                    <option key={priority.id} value={priority.departmentOrProject}>
                      {priority.departmentOrProject}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="" className="form-label">
                  Interviewer<span className="text-danger ml-1">*</span>
                </label>
                <Select
                  isMulti
                  name="colors"
                  placeholder="Assign"
                  options={interviewers}
                  value={interviewerIds}
                  onChange={handleAssignSelectChange}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="" className="form-label ">
                  From<span className="text-danger ml-1">*</span>
                </label>
                <div className="row">
                  <div className="col-md-6">
                    <DatePicker
                      selected={from}
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      // onChange={(date)=>setFrom(date)}
                      onChange={(date) => handleFromDateChange(date)}
                      showYearDropdown
                      showMonthDropdown
                      placeholderText="Select date "
                      minDate={new Date()}
                    />
                  </div>
                  <div className="col-md-6">
                    <DatePicker
                      selected={startTime}
                      //  onChange={(time) => {setStartTime(time)}}
                      onChange={(time) => handleFromTimeChange(time)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      className="form-control  interTime"
                      placeholderText="Select time"
                    />
                  </div>
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="" className="form-label ">
                  To<span className="text-danger ml-1">*</span>
                </label>
                <div className="row">
                  <div className="col-md-6">
                    <DatePicker
                      selected={to}
                      onChange={(date) => setTo(date)}
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      showYearDropdown
                      showMonthDropdown
                      placeholderText="Select date "
                      minDate={new Date()}
                    />
                  </div>
                  <div className="col-md-6">
                    <DatePicker
                      selected={endTime}
                      onChange={(time) => {
                        setEndTime(time);
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      className="form-control  interTime"
                      placeholderText="Select time"
                    />
                  </div>
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="" className="form-label">
                  Interview Link
                </label>
                <textarea
                  type="text"
                  className="form-control textareaheight"
                  placeholder="Interview Link.."
                  value={interviewLink}
                  onChange={(e) => setInterviewLink(e.target.value)}
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="" className="form-label">
                  Suggestion
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your Suggestions"
                  value={suggestion}
                  onChange={(e) => setSuggestion(e.target.value)}
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="" className="form-label me-2">
                  Interview Type<span className="text-danger ml-1">*</span>
                </label>
                <div className="noticePer">
                  <span
                    className={`skill-span me-1 ${interviewType === "Offline" && "active"
                      }`}
                    onClick={() => setInterviewType("Offline")}
                  >
                    Offline
                  </span>
                  <span
                    className={`skill-span me-1 ${interviewType === "Online" && "active"
                      }`}
                    onClick={() => setInterviewType("Online")}
                  >
                    Online
                  </span>
                </div>
              </div>


            </div>
          </div>

          <div className="childIssueses pb-3 d-block">
            <button className="btn btn-btn1 btn-btn me-2" onClick={createInterview}>
              Schedule
            </button>
            <button
              className="btn btn-btn2 btn-btn"
              onClick={() => {
                resetForm();
                onClose();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        {showPopup && (
          <ConfirmationPopup
            title={title}
            isLoading={isLoading}
            schedule={scheduleInterview}
            Cancel={Cancel}
          />
        )}
      </div>
    </div>
  );
}

export default ScheduleInterviewPopup;
